<template>
  <div class="header-back">
    <a class="header-back-btn" role="button" @click.prevent="group1.historyBack"><FontawesomeIcon :icon="['far','angle-left']" size="lg" /></a>
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed } from '@vue/composition-api'
import router from '@/router'

export default defineComponent({
  name: 'SPButtonHistoryBack',
  props: {
    action: {
      type: Function,
      default: null
    }
  },
  setup (props, context) {

    const group1 = reactive({
      historyBack: () => {
        if (props.action) {
          props.action()
        } else {
          router.go(-1)
        }
      }
    })
   
    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
.header-back {
  cursor: pointer;
}
</style>
